import { Api } from '@shared/api';

import type { SelectionReadOneResponse, SelectionsReadManyResponse, SelectionPrivateReadOneResponse } from '../types';

export class SelectionApi extends Api {
  public async readOnePublic(slug: string): Promise<SelectionReadOneResponse> {
    const response = await this.fetch(`${this.baseUrl}/selections/${slug}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return response.json();
  }

  public async readMany(config: Record<string, string> | URLSearchParams): Promise<SelectionsReadManyResponse> {
    const response = await this.fetch(`${this.baseUrl}/selections?${config}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return response.json();
  }

  public async readOnePrivate(token: string): Promise<SelectionPrivateReadOneResponse> {
    const res = await this.fetch(`${this.baseUrl}/selections/token/${token}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return res.json();
  }

  public async readTotalCount(config: Record<string, string> | URLSearchParams): Promise<number> {
    const response = await this.fetch(`${this.baseUrl}/selections/total-count?${config}`);

    const { total_count: totalCount } = await response.json();

    return totalCount;
  }
}
